"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotConnectedContentVariant = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var PersonalIntegration = _interopRequireWildcard(require("../../../PersonalIntegration"));

var _user = require("../../../Shared/store/user/user.selectors");

var _hooks = require("../../../CampaignSettings/hooks");

var _IntegrationProtip = _interopRequireDefault(require("./IntegrationProtip"));

var _emailIntegration = require("./emailIntegration.styles");

var NotConnectedContentVariant;
exports.NotConnectedContentVariant = NotConnectedContentVariant;

(function (NotConnectedContentVariant) {
  NotConnectedContentVariant["Info"] = "info";
  NotConnectedContentVariant["Warning"] = "warning";
})(NotConnectedContentVariant || (exports.NotConnectedContentVariant = NotConnectedContentVariant = {}));

var NotConnectedContent = function NotConnectedContent(_ref) {
  var teamId = _ref.teamId,
      sendAsId = _ref.sendAsId,
      isDkimProvider = _ref.isDkimProvider,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? NotConnectedContentVariant.Info : _ref$variant,
      children = _ref.children;
  var dispatch = (0, _reactRedux.useDispatch)();
  var currentUserId = (0, _reactRedux.useSelector)(_user.getUserId);

  var _useTeamMembers = (0, _hooks.useTeamMembers)(teamId),
      useGetById = _useTeamMembers.useGetById;

  var sendAs = useGetById(sendAsId);
  var isSendAsUsed = currentUserId !== sendAsId;
  var handleIntegrationClick = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    var currentPath = "".concat(window.location.pathname).concat(window.location.search);
    var scopes = {
      email: !isDkimProvider,
      calendar: true
    };
    var service = event.currentTarget.dataset.service;
    dispatch(PersonalIntegration.actions.openIntegrationService({
      service,
      path: currentPath,
      scopes
    }));
  }, [dispatch, isDkimProvider]);
  var sendAsdInfo = sendAs ? "- ".concat(sendAs.firstName, " ").concat(sendAs.lastName, " (").concat(sendAs.email, ") ") : '';
  var scopes = isDkimProvider ? 'calendar' : 'email & calendar';
  var title = isSendAsUsed ? "This team member ".concat(sendAsdInfo, " is missing their ").concat(scopes, " connection.") : "Please connect your ".concat(scopes, " account");
  var isWarning = variant === NotConnectedContentVariant.Warning;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: [_emailIntegration.styles.wrapper, _emailIntegration.styles[variant]]
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "exclamation-circle",
    color: isWarning ? 'error.main' : 'primary.main'
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    ml: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: _emailIntegration.styles.title
  }, title), /*#__PURE__*/_react.default.createElement(_IntegrationProtip.default, {
    isDkimProvider: isDkimProvider
  }), !isSendAsUsed && /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: 1,
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.EmailIntegrationButton, {
    signIn: true,
    variant: "google",
    onClick: handleIntegrationClick,
    "data-service": "google"
  }), /*#__PURE__*/_react.default.createElement(_ui.EmailIntegrationButton, {
    signIn: true,
    variant: "outlook",
    onClick: handleIntegrationClick,
    "data-service": "outlook"
  })), children));
};

var _default = NotConnectedContent;
exports.default = _default;